import { httpservice } from '../services';
import { constants } from '../constant/constant';

export const requestForSmsSendAtLogin = (object) => httpservice()
  .post(`${constants.API.SMS_GENERATE_LOGIN}`, object)
  .then((response) => response.data)
  .catch((error) => (error.response && error.response.data ? error.response.data : error));

export const verifySmsAtLogin = (object) => httpservice()
  .post(`${constants.API.SMS_VERIFY_LOGIN}`, object)
  .then((response) => response.data.response)
  .catch((error) => (error.response && error.response.data ? error.response.data : error));
